<template>
    <div class="document-list-item">
        <div class="document-item-content">
            <div class="item-row">
                <div class="primary">
                    <span class="mr-1 display-inline-flex" v-html="statusHTMLRenderer(item['status'])"></span>
                    <span class="document-id">{{item['document_id']}}</span>
                    <span class="separator"></span>
                    <span>{{item['custom_data']['stock_code']}}</span>
                    <span class="separator"></span>
                    <span>{{item['custom_data']['release_date'].substr(0, 10)}}</span>
                </div>
                <slot name="padding"></slot>
                <button v-if="inEditWorkMode && showUnbindButton"
                        class="ml-auto edit-involved-button" @click.stop="$emit('unbindSerial')">Unbind
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {documentStatusIdToLabel, statusHTMLRenderer} from "@/config";
    import {userSettingsManager, workModeEdit} from "@/utils";

    export default {
        name: "DocumentListItem",
        data() {
            return {
                documentStatusIdToLabel,
            }
        },
        props: [
            'item',
            'showUnbindButton'
        ],
        methods: {
            statusHTMLRenderer: statusHTMLRenderer,
        },
        computed: {
            workMode() {
                return userSettingsManager.getWorkMode();
            },
            inEditWorkMode() {
                return this.workMode === workModeEdit;
            },
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/variables';

    .document-item-content {
        padding: 0.5rem 0.6rem;

        & > *:not(:last-child) {
            margin-bottom: 0.25rem;
        }

        .property-name {
            color: gray;
        }

        .document-id {
            font-weight: 500;
        }

        .separator {
            &:before {
                content: '\2022';
                margin: 0 0.15rem;
            }
        }

        .item-row {
            display: flex;
            align-items: center;

            & > * {
                white-space: nowrap;
            }

            .primary {
                overflow: hidden;
                text-overflow: ellipsis;

                & > * {
                    white-space: nowrap;
                    vertical-align: middle;
                }
            }
        }
    }
</style>
